import React from 'react'

export default function DpsLoadingIndicator(props) {
  return (
    <div className="dps-loading-indicator" style={{ display: props.isLoading ? 'block' : 'none' }}>
      <div className="line"></div>
      <div className="subline inc"></div>
      <div className="subline dec"></div>
    </div>
  )
}
